import gql from "graphql-tag";

export default gql`
  mutation updateCommChannelSetting($input: UpdateCommChannelSettingInput!) {
    updateCommChannelSetting(input: $input) {
      domain
      typeValue
      configs {
        code
        commList
        senderList {
          mobile
          email
          username
          name
        }
      }
    }
  }
`;
